/*
 * @Author: xinxinfeng 2273234784@qq.com
 * @Date: 2024-07-01 14:11:23
 * @LastEditors: xinxinfeng 2273234784@qq.com
 * @LastEditTime: 2026-05-14 16:14:30
 * @FilePath: \crane-safety-manager\src\slices\vehicles\thunk.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createAsyncThunk } from '@reduxjs/toolkit';
import _ from 'lodash';
import { toast } from 'react-toastify';

import { APIClient } from '../../helpers/api_helper';
import * as ToastHelper from '../../helpers/toast_helper';

const prefix = 'vehicle';
const tname = '车辆';

export const getAll = createAsyncThunk(`${prefix}/get-all`, async function (siteId) {
    const params = {};
    if (!_.isEmpty(siteId)) {
        params['siteId'] = siteId;
    }
    const { data } = await APIClient.get('/vehicles', { params });
    return data;
});

export const create = createAsyncThunk(`${prefix}/create`, async function (payload) {
    try {
        const response = await APIClient.post('/vehicles', payload);
        ToastHelper.createSucceeded(tname);
        return response.data;
    } catch (error) {
        ToastHelper.createFailed(tname);
        throw error;
    }
});

export const update = createAsyncThunk(`${prefix}/update`, async function (payload) {
    try {
        const response = await APIClient.put(`/vehicles/${payload.id}`, payload);
        ToastHelper.updateSucceeded(tname);
        return response.data;
    } catch (error) {
        ToastHelper.updateFailed(tname);
        throw error;
    }
});

export const remove = createAsyncThunk(`${prefix}/remove`, async function (id) {
    try {
        await APIClient.delete(`/vehicles/${id}`);
        ToastHelper.removeSucceeded(tname);
        return id;
    } catch (error) {
        ToastHelper.removeFailed(tname);
        throw error;
    }
});

export const getById = createAsyncThunk(`${prefix}/get-by-id`, async function (id) {
    const { data } = await APIClient.get(`/vehicles/${id}`);
    return data;
});

export const getLogs = createAsyncThunk(`${prefix}/logs`, async function (vehicleId) {
    const { data } = await APIClient.get(`/vehicles/${vehicleId}/logs`);
    return data;
});

export const getLogsPartial = createAsyncThunk(`${prefix}/logsPartial`, async function (vehicleId) {
    const { data } = await APIClient.get(`/vehicles/${vehicleId}/logs-partial`);
    return data;
});

export const getLastHeartBeat = createAsyncThunk(`${prefix}/last-heart-beat`, async function (vehicleId) {
    const { data } = await APIClient.get(`/vehicles/${vehicleId}/last-heartbeat`);
    return data;
});

export const getYs7LiveAddr = createAsyncThunk(`${prefix}/live_addr`, async function (serial) {
    serial = serial || '';
    try {
        const { data } = await APIClient.get(`/ys7/live-addr?deviceSerial=${serial}`);
        return data;
    } catch (error) {
        // const eMsg = _.get(error, 'response.data.message', '');
        // let msg = '暂无云视频数据';
        // if (String(eMsg).includes('萤石')) {
        //     msg = eMsg;
        // }
        // toast.error(msg, { autoClose: 3000 });
        throw error;
    }
});

export const getLastestStatus = createAsyncThunk(`${prefix}/latest-status`, async function () {
    const { data } = await APIClient.get(`/vehicles/latest-status`);
    return data;
});